//export const baseURL = "http://localhost:5000";
export const baseURL = "https://api.britanicasalud.com.ar/bs";